export default "__VITE_ASSET__DJ55_sii__"